import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient} from '@angular/common/http';
import { Util } from '../util.service';

@Injectable({
  providedIn: 'root'
})

export class StudentClassService {
  baseurl = Util.GetBaseUrl();

  constructor(private http: HttpClient, public router: Router) { }

  viewStudentClass() {
    return this.http.get(this.baseurl +'/api/StudentClasses/GetStudentClasses')
  }

  viewClassStudents(classId) {
    return this.http.get(this.baseurl + `/api/Student/GetStudentsByClass?ClassId=${classId}`)
  }

  addStudentClass(studentClass) {
    console.log(studentClass);
    return this.http.post(this.baseurl + '/api/StudentClasses', studentClass)
  }

  editStudentClass(id, studentClassForm) {
    console.log(studentClassForm);
    return this.http.put(this.baseurl +`/api/StudentClasses/${id}`, studentClassForm)
  }

  deleteStudentClass(id) {
    console.log(id);
    return this.http.delete(this.baseurl+`/api/StudentClasses/${id}`)
  }
}
